import React from 'react';
import {
  Button, Col, ModalFooter, Row,
} from 'reactstrap';
import PropTypes from 'prop-types';
import notVerifiedUser from '../../assets/img/other/notVerifiedUser.svg';
import SettingsCard from '../../views/Pages/components/SettingsCard/SettingsCard';
import ModalComponent from './ModalComponent';

const NotVerifiedUserModal = ({ onToggle, isOpen }) => (
  <ModalComponent
    title="You are not verified"
    image={notVerifiedUser}
    isOpen={isOpen}
    onToggle={onToggle}
    name="NotVerifiedUser"
    userStatus="not-verified"
  >
    <p className="modal-text font-16 m-0 text-center">
      Please provide the necessary information to complete your account
    </p>
    <Row className="mt-4">
      <Col lg={6}>
        <SettingsCard
          size="small"
          href="/home"
          className="mr-3"
        >
          <p className="m-0 ml-3 font-14 my-auto">Complete your details</p>
        </SettingsCard>
      </Col>
    </Row>
    <ModalFooter className="border-0 p-0 flex-column mb-2">
      <Button className="m-0 issuer-button-primary" size="lg" block onClick={onToggle}>Got it</Button>
    </ModalFooter>
  </ModalComponent>
);

NotVerifiedUserModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default NotVerifiedUserModal;
